<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="selectedUrl ? `transaction/placement-behavior/${inputs.id}` : `transaction/placement-behavior`"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_behavior" class="col-sm-3 mb-0">
						Behavior
					</label>
					<p class="col-sm-9 mb-0">{{ inputs.behavior }}</p>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_score" class="col-sm-3 mb-0">
						Score
					</label>
					<app-input
						id="inputs_score"
						class="col-sm-9"
						type="number"
						v-model="inputs.score"
						placeholder="Score"
						:required="true"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { ClassTrialBehaviorFormMixin } from "./ClassTrialBehaviorFormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "ClassTrialBehaviorTableForm",
	mixins: [ClassTrialBehaviorFormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
	},
	data() {
		return {
			preloader: false,
			inputs: {},
			phone: "",
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.inputs.score = parseInt(this.inputs.score);
			if (this.inputs.score > 5 || this.inputs.score < 0) {
				this.$toastr.e("Score must be between 0 and 5");
				return;
			}
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			if (response.data.phone) this.phone = response.data.phone;
			this.inputs = response.data;
			this.preloader = false;
		},
	},
};
</script>
